import { render, staticRenderFns } from "./ArrayButton.vue?vue&type=template&id=46af87dc&scoped=true&"
import script from "./ArrayButton.vue?vue&type=script&lang=js&"
export * from "./ArrayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46af87dc",
  null
  
)

export default component.exports